import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";

import { saveUserProfile } from "./saveUser";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
   appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

/* =====================
   LOGIN
===================== */
export const loginWithGoogle = async () => {
  const result = await signInWithPopup(auth, provider);
  await saveUserProfile(result.user);

  const user = result.user;

  const profile = {
    type: "google",
    uid: user.uid,
    name: user.displayName,
    email: user.email,
    photo: user.photoURL,
    preferredLanguage: "all",
  };

  localStorage.setItem("user", JSON.stringify(profile));
};

/* =====================
   LOGOUT
===================== */
export const logoutUser = async () => {
    await signOut(auth);
  };
/* =====================
   CURRENT USER
===================== */
export const getCurrentUser = () => {
    const firebaseUser = auth.currentUser;
  
    if (firebaseUser) {
      return {
        id: firebaseUser.uid,
        email: firebaseUser.email,
        name: firebaseUser.displayName,
        photo: firebaseUser.photoURL,
        type: "google",
      };
    }
  
    // ✅ FALLBACK TO GUEST
    return {
      type: "guest",
    };
  };